import { isNil, startCase } from 'lodash';
import {
  InformationInputType,
  InspectionScopeItemGridRowType,
  ReportInformationCannotAnswerReason,
  ReportInformationStatus,
  ReportInformationType
} from '../../types';

export const getScopeItemProgress = (
  { clientProgress, progress }: InspectionScopeItemGridRowType,
) => `${Math.ceil(clientProgress || progress || 0)}%`;

export const getAnswer = (information: ReportInformationType): string => {
  if (!information) return '';
  const {
    status,
    cannotAnswer,// support legacy field
    cannotAnswerReason,
    questionType,
    value,
    units,
  } = information;

  if (
    status === ReportInformationStatus.CannotAnswer
    || cannotAnswer
  ) {
    if (cannotAnswerReason) {
      return cannotAnswerReason === ReportInformationCannotAnswerReason.Other
        ? 'Refer to limitations'
        : startCase(cannotAnswerReason);
    }
    return 'Cannot Answer';
  }

  if (isNil(value)) return '';

  switch (questionType) {
    case 'string': {
      const parsedValue = JSON.parse(value);
      return Array.isArray(parsedValue) ? parsedValue.join(', ') : parsedValue;
    }
    case 'integer': {
      const integerValue = JSON.parse(value);
      return (units ? `${integerValue} ${units.toLowerCase()}` : integerValue).toString();
    }
    case 'boolean': {
      return JSON.parse(value) ? 'Yes' : 'No';
    }
    default:
      return '';
  }
};

export const filterApplianceInformation = (
  ri: ReportInformationType,
) => ri.reportApplianceInformation || ri.questionType.indexOf('appliance') > -1;

export const filterInformation = (
  ri: ReportInformationType,
) => ri.questionType !== InformationInputType.media
  && ri.questionType !== InformationInputType.appliance
  && ri.questionType !== InformationInputType.applianceTag
  || ri.status === ReportInformationStatus.CannotAnswer;
